export default {"src":"/_next/static/media/WorkbookIcon.9f947375.svg","height":76,"width":59};